export const getCustomSelectStyles = (themeMode: string, fullWidth: boolean = false) => ({
  container: (provided: any) => ({
    ...provided,
    width: fullWidth ? '100%' : '20rem',
  }),
  control: (provided: any, state: { isFocused: boolean }) => ({
    ...provided,
    backgroundColor: themeMode === 'dark' ? '#161C24' : '#fff',
    color: themeMode === 'dark' ? '#fff' : '#000',
    borderColor: state.isFocused ? (themeMode === 'dark' ? '#fff' : '#000') : '#ced4da',
    boxShadow: state.isFocused ? 'none' : 'none',
    borderRadius: '0.375rem',
    padding: '2px',
    marginTop: '10px',
    '&:hover': {
      borderColor: themeMode === 'dark' ? '#fff' : '#000',
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: themeMode === 'dark' ? '#161C24' : '#fff',
  }),
  option: (provided: any, state: { isSelected: boolean; isFocused: boolean }) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#B91C1C'
      : state.isFocused
      ? themeMode === 'dark'
        ? '#30363d'
        : '#e5e7eb'
      : 'transparent',
    color: state.isSelected ? '#fff' : themeMode === 'dark' ? '#fff' : '#000',
    '&:active': {
      backgroundColor: state.isSelected
        ? '#B91C1C'
        : themeMode === 'dark'
        ? '#30363d'
        : '#e5e7eb',
    },
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: themeMode === 'dark' ? '#fff' : '#000',
  }),
});
